var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:[_vm.$style.progression],style:({ width: (_vm.progression + "%"), background: _vm.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }